/**
 *  Date    : 2019/9/23
 *  Author  : CastileMan
 *  Declare : 分页相关数据拼接方法
 */
import Immutable from 'seamless-immutable';

export default function page(prevPageBean = {}) {
  const { recordList } = prevPageBean;
  return {
    append(nextPageBean) {
      if(!Immutable.isImmutable(nextPageBean)) {
        nextPageBean = Immutable(nextPageBean);
      }

      if(nextPageBean.currentPage > prevPageBean.currentPage) {
        return nextPageBean.set('recordList', recordList.concat(nextPageBean.recordList));
      } else {
        return nextPageBean;
      }
    },

    unshift(nextPageBean) {
      let nextPageRecordList = nextPageBean.recordList;
      if(Immutable.isImmutable(nextPageBean)) {
        nextPageRecordList = Immutable(Immutable.asMutable(nextPageBean.recordList).reverse());
      } else {
        nextPageRecordList.reverse();
        nextPageBean = Immutable(nextPageBean);
      }

      if(nextPageBean.currentPage > prevPageBean.currentPage) {
        return nextPageBean.set('recordList', nextPageRecordList.concat(recordList));
      } else if(nextPageBean.currentPage === 0) {
        return nextPageBean.set('recordList', nextPageRecordList);
      } else {
        return prevPageBean;
      }
    }
  };
}
